const initTabsElement = (tabsElement) => {
    const navElements = tabsElement.querySelectorAll('.tabs__navigation li');
    const items = tabsElement.querySelectorAll('.tabs__item');
    navElements.forEach((navElement) => {
        if (!navElement.dataset.id) {
            return;
        }
        const contentElement = document.getElementById(navElement.dataset.id);
        if (!contentElement) {
            return;
        }
        navElement.addEventListener('click', () => {
            navElements.forEach((currentNavElement) => currentNavElement.classList.toggle('active', navElement === currentNavElement));
            items.forEach((currentContentElement) => currentContentElement.classList.toggle('active', currentContentElement.id === navElement.dataset.id));
        });
    });
};
export const initTabs = () => {
    const tabsElements = document.querySelectorAll('.tabs');
    tabsElements.forEach((tabsElement) => {
        initTabsElement(tabsElement);
    });
};
